module.exports = __webpack_public_path__ + "img/密码.df5e381e.svg";